import { type I18n } from "@common/lib/i18n";
import validate from "card-validator";
import { type CreditCardInfo } from "./component";

export const validateCreditCard = (i18n: I18n, value: CreditCardInfo): string | null => {
  if (value.cardNumber) {
    const r = validate.number(value.cardNumber);
    if (!r.isPotentiallyValid && !r.isValid) return i18n.errorInvalidCardNumber;
  } else {
    return i18n.errorCardNumberRequired;
  }

  if (value.expirationDate) {
    const r = validate.expirationDate(value.expirationDate);
    if (!r.isPotentiallyValid && !r.isValid) return i18n.errorInvalidCardExpirationDate;
  } else {
    return i18n.errorCardExpirationDateRequired;
  }

  if (value.cardCode) {
    const r = validate.cvv(value.cardCode);
    if (!r.isPotentiallyValid && !r.isValid) return i18n.errorInvalidCardExpirationDate;
  } else {
    return i18n.errorCardCVVRequired;
  }

  return null;
};
